import { render, staticRenderFns } from "./tableBase.vue?vue&type=template&id=09fbbae1&scoped=true&"
import script from "./tableBase.vue?vue&type=script&lang=js&"
export * from "./tableBase.vue?vue&type=script&lang=js&"
import style0 from "./tableBase.vue?vue&type=style&index=0&id=09fbbae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbbae1",
  null
  
)

export default component.exports